<template lang="pug">
  h2.challenge-title
    slot
</template>
<script>
export default {
  name: 'ChallengeTitle',
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .challenge-title
    width 100%
    margin-bottom 25px
    color $cyprus-color
    font-weight 600
    font-size 1.2rem
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeTitle.vue